$('#base-form').validate({
    ignore: [],
    errorElement: 'div',
    rules: {
        fio: {
            required: true,
            minlength: 2,
            maxlength: 80
        },
        phone: {
            required: true,
            minlength: 10,
            maxlength: 22
        },
        email: {
            required: true,
            email: true,
            minlength: 5,
            maxlength: 35
        },
    },
    submitHandler: function submitHandler(form, event) {
        event.preventDefault();
        $('.base-popup-button').addClass('load');
        form.submit()
    }
});
$('#phoner').mask('+38(999)-999-99-99')
